export default __webpack_public_path__ + "static/media/1353.2141cb92.png";